<template>
  <div class="wrapper clearfix">
    <div class="demo-upload-list" v-for="(item, index) in imgList" :key="index">
      <template v-if="!fileType">
        <img :src="item" style="width: 100%;height: 130%;object-fit: cover;" />
        <div class="demo-upload-list-cover">
          <Icon
            type="ios-eye-outline"
            @click.native="handleView(item)"
            v-if="checkType(item)=='png'||checkType(item)=='jpg'||checkType(item)=='jpeg'"
          ></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel"></Icon>
        </div>
      </template>
      <template v-if="fileType==='many'">
        <img v-if="checkType(item)=='pdf'" src="@/static/images/cc_pdf.png" class="avatar" />
        <img
          v-else-if="checkType(item)=='xls'||checkType(item)=='xlsx'"
          src="@/static/images//cc_excel.png"
          class="avatar"
        />
        <img
          v-else-if="checkType(item)=='docx'||checkType(item)=='doc'"
          src="@/static/images/cc_word.png"
          class="avatar"
        />
        <img
          v-else-if="checkType(item)=='ppt'||checkType(item)=='pptx'"
          src="@/static/images/cc_ppt.png"
          class="avatar"
        />
        <img :src="item" style="width: 120px" v-else />
        <div class="demo-upload-list-cover">
          <Icon
            type="ios-eye-outline"
            @click.native="handleView(item)"
            v-if="checkType(item)=='png'||checkType(item)=='jpg'||checkType(item)=='jpeg'"
          ></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel"></Icon>
        </div>
      </template>
      <template v-if="fileType==='video'">
        <video :src="item" style="width: 120px" />
        <div class="demo-upload-list-cover">
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel"></Icon>
        </div>
      </template>
    </div>
    <Upload
      v-if="isShowUpLoad"
      :multiple="muti ? true : false"
      type="drag"
      action="/"
      class="uploadBoxs"
      :before-upload="handleUpload"
    >
      <div style="padding: 20px 0">
        <Icon type="ios-add" size="52" style="color: #3399ff"></Icon>
        <span v-if="txt">{{ txt }}</span>
      </div>
    </Upload>
    <Modal
      v-model="visible"
      :footer-hide="true"
      :closable="false"
      :width="modalWidth ? modalWidth : '600px'"
    >
      <img v-zoom v-drag :src="curImg" v-if="visible" style="width: 100%" />
    </Modal>
    <p class="tip">{{ tip }}</p>
  </div>
</template>

<script>
export default {
  components: {},
  name: "upLoad",
  props: {
    fileType: "",
    muti: Boolean,
    arr: [Array, String, Object],
    txt: String,
    tip: String,
    modalWidth: String,
    isDel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      curImg: "",
      imgList: [],
      isShowMask: []
    };
  },
  watch: {
    arr: {
      handler(newVal) {
        if (newVal) {
          if (newVal instanceof Array) {
            this.imgList = newVal.map(item => {
              if (item.url) {
                return item.url;
              } else {
                return item;
              }
            });
          } else {
            this.imgList = [newVal];
          }
        } else {
          this.imgList = "";
        }
      },
      immediate: true, //刷新加载 立马触发一次handler
      // deep: true  // 可以深度检测到 person 对象的属性值的变化
    }
  },
  computed: {
    isShowUpLoad() {
      if (!this.muti) {
        if (this.imgList.length > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        //多文件
        return true;
      }
    }
  },
  methods: {
    checkType(item) {
      return item
        .split(".")
        .pop()
        .toLowerCase();
    },
    handleView(item) {
      this.curImg = item;
      this.visible = true;
    },
    handleRemove(index) {
      this.imgList.splice(index, 1);
      this.$emit("remove", index);
    },
    deleCur(index) {
      this.imgList.splice(index, 1);
    },
    mouseover(index) {
      this.$set(this.isShowMask, index, true);
      console.log(this.isShowMask);
    },
    mouseleave(index) {
      this.$set(this.isShowMask, index, false);
    },
    handleUpload(file) {
      //  上传文件只能是 PDF/EXCEL/WORD/PPT/JPG/PNG 格式!
      if (this.fileType) {
        const reg =
          this.fileType === "video"
            ? /\.(mp4)$/
            : /\.(png|jpg|jpeg|pdf|xlsx|xls|doc|docx|ppt|pptx|)$/;
        const txt =
          this.fileType === "video" ? "视频" : "PDF/EXCEL/WORD/PPT/JPG/PNG";
        if (!reg.test(file.name.toLowerCase())) {
          this.$Message.error(`上传格式不正确，请上传${txt}格式文件`);
          return false;
        }
      } else {
        const reg = /\.(png|jpg|jpeg)$/;
        const txt = "图片";
        if (!reg.test(file.name.toLowerCase())) {
          this.$Message.error(`上传格式不正确，请上传${txt}格式文件`);
          return false;
        }
      }
      this.$emit("upload", file);
      return false;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.tip {
  margin-top: 10px;
  color: #727c8e;
  align-items: self-end;
  display: flex;
}
/deep/ .ivu-modal-content {
  background: transparent;
  box-shadow: none;
  outline: none;
}

/deep/ .ivu-modal-body {
  background: transparent;
}

.wrapper {
  display: flex;
  flex-wrap: wrap;
  .demo-upload-list {
    display: inline-block;
    width: 120px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
    margin-bottom: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);

    align-items: center;
    justify-content: center;
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: flex;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .imgList {
    float: left;

    li {
      position: relative;
      float: left;
      width: 120px;
      height: 120px;
      margin: 10px;

      .close {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        text-align: center;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          margin-right: 10px;
        }

        &:hover {
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      img {
        &:hover {
          cursor: pointer;
        }

        width: 100%;
        height: 100%;
      }
    }
  }

  .uploadBoxs {
    float: left;
    width: 120px;
    height: 120px;
    // margin: 10px;

    /deep/ .ivu-upload {
      height: 100%;

      > div {
        height: 100%;
      }

      .ivu-icon {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
